var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: false,
          searchBaseItems: [],
          btns: { search: true, reset: true }
        },
        on: { onChange: function() {} }
      }),
      _c(
        "div",
        { staticClass: "bairun-table-btns" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.onAddFullReduce }
            },
            [_vm._v("满减活动")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.onAddFullDiscount }
            },
            [_vm._v("满折活动")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.onAddFullGive }
            },
            [_vm._v("满赠活动")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.onAddFullMore }
            },
            [_vm._v("加价购")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.onAddOnePrice }
            },
            [_vm._v("一口价套餐")]
          )
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            height: "45rem",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "便利店名称", prop: "sellerId", width: "180px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "活动编号", prop: "activityNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "activityName" }
          }),
          _c("el-table-column", {
            attrs: { label: "自定义条码", prop: "goodsNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "活动类型", prop: "ruleTypeName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.ruleTypeName))]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "startTime" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.startTime)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "endTime" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.endTime)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "活动状态", prop: "activityStatus", width: "80px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.activityStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    scope.row.activityStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "danger", effect: "plain" } },
                          [_vm._v("禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作区", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c("el-button", [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onView(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-view" } },
                                  [_vm._v("查看")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onUpdate(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-edit" } },
                                  [_vm._v("编辑")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onAble(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-check" } },
                                  [_vm._v("启用")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onDisable(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-close" } },
                                  [_vm._v("禁用")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onDelete(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-delete" } },
                                  [_vm._v("删除")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewFullReduceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewFullReduceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sellerName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sellerName", $$v)
                              },
                              expression: "formData.sellerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间范围：" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "满减方式：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.formData.ruleTypeSub,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "ruleTypeSub", $$v)
                                },
                                expression: "formData.ruleTypeSub"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("每满减")
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("阶梯满减")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.formData.ruleTypeSub == 2
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "满" } },
                            [
                              _c("el-input-number", {
                                model: {
                                  value:
                                    _vm.formData.activityRuleSingle[0].limits,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData.activityRuleSingle[0],
                                      "limits",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.activityRuleSingle[0].limits"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "减" } },
                            [
                              _c("el-input-number", {
                                model: {
                                  value:
                                    _vm.formData.activityRuleSingle[0].discount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData.activityRuleSingle[0],
                                      "discount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.activityRuleSingle[0].discount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "最高减：" } },
                            [
                              _c("el-input-number", {
                                model: {
                                  value:
                                    _vm.formData.activityRuleSingle[0]
                                      .discountMax,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData.activityRuleSingle[0],
                                      "discountMax",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.activityRuleSingle[0].discountMax"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _vm.formData.ruleTypeSub == 1
                  ? _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "满" } },
                              [
                                _c("el-input-number", {
                                  model: {
                                    value: item.limits,
                                    callback: function($$v) {
                                      _vm.$set(item, "limits", $$v)
                                    },
                                    expression: "item.limits"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "减" } },
                              [
                                _c("el-input-number", {
                                  model: {
                                    value: item.discount,
                                    callback: function($$v) {
                                      _vm.$set(item, "discount", $$v)
                                    },
                                    expression: "item.discount"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择商品：" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选商品：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewFullDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewFullDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sellerName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sellerName", $$v)
                              },
                              expression: "formData.sellerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间范围：" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "满折方式：", prop: "ruleTypeSub" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.formData.ruleTypeSub,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "ruleTypeSub", $$v)
                                },
                                expression: "formData.ruleTypeSub"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("满额折")
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("满件折")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "满：" } },
                          [
                            _c("el-input-number", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: item.limits,
                                callback: function($$v) {
                                  _vm.$set(item, "limits", $$v)
                                },
                                expression: "item.limits"
                              }
                            }),
                            _vm.formData.ruleTypeSub == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("元")]
                                )
                              : _vm._e(),
                            _vm.formData.ruleTypeSub == 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("件")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "享：" } },
                          [
                            _c("el-input-number", {
                              attrs: {
                                clearable: "",
                                placeholder: "0.95表示95折"
                              },
                              model: {
                                value: item.discount,
                                callback: function($$v) {
                                  _vm.$set(item, "discount", $$v)
                                },
                                expression: "item.discount"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("折")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "最高减：" } },
                          [
                            _c("el-input-number", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: item.discountMax,
                                callback: function($$v) {
                                  _vm.$set(item, "discountMax", $$v)
                                },
                                expression: "item.discountMax"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [_c("el-form-item")],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择活动商品：" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选商品：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewFullGiveDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewFullGiveDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sellerName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sellerName", $$v)
                              },
                              expression: "formData.sellerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "满增方式：", prop: "ruleTypeSub" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.formData.ruleTypeSub,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "ruleTypeSub", $$v)
                                },
                                expression: "formData.ruleTypeSub"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("满额赠")
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("满件赠")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "满：",
                              prop: "activityRuleList." + index + ".limits",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: item.limits,
                                callback: function($$v) {
                                  _vm.$set(item, "limits", $$v)
                                },
                                expression: "item.limits"
                              }
                            }),
                            _vm.formData.ruleTypeSub == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("元")]
                                )
                              : _vm._e(),
                            _vm.formData.ruleTypeSub == 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("件")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择活动商品：" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选商品：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "已选赠品：" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.giveGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "赠品数量", prop: "goodsNum" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewFullMoreDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewFullMoreDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sellerName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sellerName", $$v)
                              },
                              expression: "formData.sellerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 1 } },
                      [_c("el-form-item", { attrs: { label: "加购设置：" } })],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "满：" } },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.limits,
                                callback: function($$v) {
                                  _vm.$set(item, "limits", $$v)
                                },
                                expression: "item.limits"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "加：" } },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.extraAddMoney,
                                callback: function($$v) {
                                  _vm.$set(item, "extraAddMoney", $$v)
                                },
                                expression: "item.extraAddMoney"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商品：" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选：" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "加价购商品：" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.moreGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "加价购数量", prop: "goodsNum" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewOnePriceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewOnePriceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sellerName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sellerName", $$v)
                              },
                              expression: "formData.sellerName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "自定义条码：" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.goodsNo,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "goodsNo", $$v)
                              },
                              expression: "formData.goodsNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "套餐价格：" } },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.onePrice,
                                callback: function($$v) {
                                  _vm.$set(item, "onePrice", $$v)
                                },
                                expression: "item.onePrice"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 17 } },
                      [
                        _c("el-form-item", { attrs: { label: "" } }, [
                          _c("span", [
                            _vm._v(
                              "成本金额：" +
                                _vm._s(
                                  _vm.goodsComponentFormData.activityCostMoney
                                ) +
                                "元"
                            )
                          ]),
                          _c("span", { staticClass: "bairun-margin-l-large" }, [
                            _vm._v(
                              "销售金额：" +
                                _vm._s(
                                  _vm.goodsComponentFormData.activityGoodsMoney
                                ) +
                                "元"
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商品：", prop: "isAllGoods" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.activityGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "商品数量", prop: "goodsNum" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "最新成本价",
                                  prop: "goodsLatestCost"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.fullReduceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.fullReduceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "fullReduceFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled:
                                  _vm.formData.activityNo &&
                                  _vm.formData.activityNo != ""
                              },
                              on: { change: _vm.onSellerChange },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "满减方式：", prop: "ruleTypeSub" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.formData.ruleTypeSub,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "ruleTypeSub", $$v)
                                },
                                expression: "formData.ruleTypeSub"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("每满减")
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("阶梯满减")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleSingle, function(item, index) {
                return _vm.formData.ruleTypeSub == 2
                  ? _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "每满：",
                                  prop:
                                    "activityRuleSingle." + index + ".limits",
                                  rules: {
                                    required: true,
                                    message: "请输入",
                                    trigger: "blur",
                                    type: "number",
                                    min: 0.01
                                  }
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: item.limits,
                                    callback: function($$v) {
                                      _vm.$set(item, "limits", $$v)
                                    },
                                    expression: "item.limits"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "减：",
                                  prop:
                                    "activityRuleSingle." + index + ".discount",
                                  rules: {
                                    required: true,
                                    message: "请输入",
                                    trigger: "blur",
                                    type: "number",
                                    min: 0.01
                                  }
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: item.discount,
                                    callback: function($$v) {
                                      _vm.$set(item, "discount", $$v)
                                    },
                                    expression: "item.discount"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "最高减：",
                                  prop:
                                    "activityRuleSingle." +
                                    index +
                                    ".discountMax",
                                  rules: {
                                    required: true,
                                    message: "请输入",
                                    trigger: "blur",
                                    type: "number",
                                    min: 0.01
                                  }
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: item.discountMax,
                                    callback: function($$v) {
                                      _vm.$set(item, "discountMax", $$v)
                                    },
                                    expression: "item.discountMax"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _vm.formData.ruleTypeSub == 1
                  ? _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "满：",
                                  prop: "activityRuleList." + index + ".limits",
                                  rules: {
                                    required: true,
                                    message: "请输入",
                                    trigger: "blur",
                                    type: "number",
                                    min: 0.01
                                  }
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: item.limits,
                                    callback: function($$v) {
                                      _vm.$set(item, "limits", $$v)
                                    },
                                    expression: "item.limits"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "减：",
                                  prop:
                                    "activityRuleList." + index + ".discount",
                                  rules: {
                                    required: true,
                                    message: "请输入",
                                    trigger: "blur",
                                    type: "number",
                                    min: 0.01
                                  }
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入"
                                  },
                                  model: {
                                    value: item.discount,
                                    callback: function($$v) {
                                      _vm.$set(item, "discount", $$v)
                                    },
                                    expression: "item.discount"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 1 } },
                          [_c("el-form-item")],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "btn-tool-balancrange",
                            attrs: { span: 1 }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-tool-balancrange",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onDeleteRule(index)
                                      }
                                    }
                                  },
                                  [_vm._v("-")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "btn-tool-balancrange",
                            attrs: { span: 1 }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onAddRule(index)
                                      }
                                    }
                                  },
                                  [_vm._v("+")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "选择活动商品：", prop: "isAllGoods" }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选商品：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddGoods("activityGoods")
                                    }
                                  }
                                },
                                [_vm._v("添加商品")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "60px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("el-button", {
                                                attrs: {
                                                  icon: "el-icon-close",
                                                  size: "mini",
                                                  circle: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onDelActivityGoods(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2275223852
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.fullDiscountDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.fullDiscountDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "fullDiscountFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled:
                                  _vm.formData.activityNo &&
                                  _vm.formData.activityNo != ""
                              },
                              on: { change: _vm.onSellerChange },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "满折方式：", prop: "ruleTypeSub" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.formData.ruleTypeSub,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "ruleTypeSub", $$v)
                                },
                                expression: "formData.ruleTypeSub"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("满额折")
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("满件折")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "满：",
                              prop: "activityRuleList." + index + ".limits",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: item.limits,
                                callback: function($$v) {
                                  _vm.$set(item, "limits", $$v)
                                },
                                expression: "item.limits"
                              }
                            }),
                            _vm.formData.ruleTypeSub == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("元")]
                                )
                              : _vm._e(),
                            _vm.formData.ruleTypeSub == 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("件")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "享：",
                              prop: "activityRuleList." + index + ".discount",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                max: 1
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  "z-index": "99",
                                  top: "-30px",
                                  color: "red",
                                  left: "0"
                                }
                              },
                              [_vm._v("注意：0.95表示95折")]
                            ),
                            _c("el-input-number", {
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                max: 1,
                                min: 0,
                                step: 0.01
                              },
                              model: {
                                value: item.discount,
                                callback: function($$v) {
                                  _vm.$set(item, "discount", $$v)
                                },
                                expression: "item.discount"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("折")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "最高减：",
                              prop:
                                "activityRuleList." + index + ".discountMax",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: item.discountMax,
                                callback: function($$v) {
                                  _vm.$set(item, "discountMax", $$v)
                                },
                                expression: "item.discountMax"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 1 } },
                      [_c("el-form-item")],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticClass: "btn-tool-balancrange",
                        attrs: { span: 1 }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn-tool-balancrange",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onDeleteRule(index)
                                  }
                                }
                              },
                              [_vm._v("-")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticClass: "btn-tool-balancrange",
                        attrs: { span: 1 }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onAddRule(index)
                                  }
                                }
                              },
                              [_vm._v("+")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "选择活动商品：", prop: "isAllGoods" }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选商品：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddGoods("activityGoods")
                                    }
                                  }
                                },
                                [_vm._v("添加商品")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "60px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("el-button", {
                                                attrs: {
                                                  icon: "el-icon-close",
                                                  size: "mini",
                                                  circle: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onDelActivityGoods(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2275223852
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.fullGiveDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.fullGiveDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "fullGiveFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled:
                                  _vm.formData.activityNo &&
                                  _vm.formData.activityNo != ""
                              },
                              on: { change: _vm.onSellerChange },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "满增方式：", prop: "ruleTypeSub" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.formData.ruleTypeSub,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "ruleTypeSub", $$v)
                                },
                                expression: "formData.ruleTypeSub"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("满额赠")
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("满件赠")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "满：",
                              prop: "activityRuleList." + index + ".limits",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: item.limits,
                                callback: function($$v) {
                                  _vm.$set(item, "limits", $$v)
                                },
                                expression: "item.limits"
                              }
                            }),
                            _vm.formData.ruleTypeSub == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("元")]
                                )
                              : _vm._e(),
                            _vm.formData.ruleTypeSub == 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bairun-form-item-label-suffix"
                                  },
                                  [_vm._v("件")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "选择活动商品：", prop: "isAllGoods" }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选商品：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddGoods("activityGoods")
                                    }
                                  }
                                },
                                [_vm._v("添加商品")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "60px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("el-button", {
                                                attrs: {
                                                  icon: "el-icon-close",
                                                  size: "mini",
                                                  circle: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onDelActivityGoods(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2275223852
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", {
                        staticClass: "bairun-required",
                        attrs: {
                          label: "选择活动赠品：",
                          prop: "giveGoodsList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "已选赠品：" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", icon: "el-icon-add" },
                              on: {
                                click: function($event) {
                                  return _vm.onAddGoods("giveGoods")
                                }
                              }
                            },
                            [_vm._v("添加赠品")]
                          ),
                          _c("br"),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.giveGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "赠品数量",
                                  prop: "goodsNum",
                                  width: "150"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          staticClass: "bairun-input-fill",
                                          staticStyle: { height: "47px" },
                                          attrs: {
                                            min: 1,
                                            placeholder: "赠品数量",
                                            "controls-position": "right"
                                          },
                                          model: {
                                            value: scope.row.goodsNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "goodsNum",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.goodsNum"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "最新成本价",
                                  prop: "goodsLatestCost"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "50px" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-close",
                                            size: "mini",
                                            circle: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onDelGiveGoods(
                                                scope.row
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.fullMoreDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.fullMoreDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "fullMoreFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled:
                                  _vm.formData.activityNo &&
                                  _vm.formData.activityNo != ""
                              },
                              on: { change: _vm.onSellerChange },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 1 } },
                      [
                        _c(
                          "i",
                          {
                            staticStyle: {
                              position: "absolute",
                              top: "15px",
                              left: "26px",
                              color: "red"
                            }
                          },
                          [_vm._v("*")]
                        ),
                        _c("el-form-item", { attrs: { label: "加购设置：" } })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bairun-empty-required",
                            attrs: {
                              label: "满：",
                              prop: "activityRuleList." + index + ".limits",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.limits,
                                callback: function($$v) {
                                  _vm.$set(item, "limits", $$v)
                                },
                                expression: "item.limits"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "bairun-empty-required",
                            attrs: {
                              label: "加：",
                              prop:
                                "activityRuleList." + index + ".extraAddMoney",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.extraAddMoney,
                                callback: function($$v) {
                                  _vm.$set(item, "extraAddMoney", $$v)
                                },
                                expression: "item.extraAddMoney"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商品：", prop: "isAllGoods" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("部分商品")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.formData.isAllGoods,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isAllGoods", $$v)
                                },
                                expression: "formData.isAllGoods"
                              }
                            },
                            [_vm._v("所有商品")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              [2].includes(_vm.formData.isAllGoods)
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "已选：" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-add"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onAddGoods("activityGoods")
                                    }
                                  }
                                },
                                [_vm._v("添加商品")]
                              ),
                              _c("br"),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.formData.activityGoodsList,
                                    border: "",
                                    stripe: "",
                                    "tooltip-effect": "dark"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "goodsName"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "规格",
                                      prop: "goodsSpecification"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "单位", prop: "goodsUnit" }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "销售价",
                                      prop: "goodsPrice"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "最新成本价",
                                      prop: "goodsLatestCost"
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "60px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("el-button", {
                                                attrs: {
                                                  icon: "el-icon-close",
                                                  size: "mini",
                                                  circle: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onDelActivityGoods(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2275223852
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "i",
                        {
                          staticStyle: {
                            position: "absolute",
                            top: "15px",
                            left: "10px",
                            color: "red"
                          }
                        },
                        [_vm._v("*")]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "加价购商品：",
                            prop: "moreGoodsList"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", icon: "el-icon-add" },
                              on: {
                                click: function($event) {
                                  return _vm.onAddGoods("moreGoods")
                                }
                              }
                            },
                            [_vm._v("添加加价购商品")]
                          ),
                          _c("br"),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.moreGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "加价购数量",
                                  prop: "goodsNum",
                                  width: "150"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          staticClass: "bairun-input-fill",
                                          staticStyle: { height: "47px" },
                                          attrs: {
                                            min: 1,
                                            placeholder: "加价购数量",
                                            "controls-position": "right"
                                          },
                                          model: {
                                            value: scope.row.goodsNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "goodsNum",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.goodsNum"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "最新成本价",
                                  prop: "goodsLatestCost"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "60px" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-close",
                                            size: "mini",
                                            circle: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onDelMoreGoods(
                                                scope.row
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.onePriceDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-bianlidian-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.onePriceDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "onePriceFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商店：", prop: "sellerId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled:
                                  _vm.formData.activityNo &&
                                  _vm.formData.activityNo != ""
                              },
                              on: { change: _vm.onSellerChange },
                              model: {
                                value: _vm.formData.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "sellerId", $$v)
                                },
                                expression: "formData.sellerId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "活动名称：", prop: "activityName" }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.activityName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "activityName", $$v)
                              },
                              expression: "formData.activityName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "时间范围：",
                            prop: "dateRangeValueArr"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              align: "right",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "自定义条码：", prop: "goodsNo" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.formData.goodsNo,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "goodsNo", $$v)
                              },
                              expression: "formData.goodsNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.activityRuleList, function(item, index) {
                return _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "套餐价格：",
                              prop: "activityRuleList." + index + ".onePrice",
                              rules: {
                                required: true,
                                message: "请输入",
                                trigger: "blur",
                                type: "number",
                                min: 0.01
                              }
                            }
                          },
                          [
                            _c("el-input-number", {
                              staticClass: "bairun-underline-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入",
                                controls: false
                              },
                              model: {
                                value: item.onePrice,
                                callback: function($$v) {
                                  _vm.$set(item, "onePrice", $$v)
                                },
                                expression: "item.onePrice"
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "bairun-form-item-label-suffix" },
                              [_vm._v("元")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 17 } },
                      [
                        _c("el-form-item", { attrs: { label: "" } }, [
                          _c("span", [
                            _vm._v(
                              "成本金额：" +
                                _vm._s(
                                  _vm.goodsComponentFormData.activityCostMoney
                                ) +
                                "元"
                            )
                          ]),
                          _c("span", { staticClass: "bairun-margin-l-large" }, [
                            _vm._v(
                              "销售金额：" +
                                _vm._s(
                                  _vm.goodsComponentFormData.activityGoodsMoney
                                ) +
                                "元"
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动商品：", prop: "isAllGoods" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", icon: "el-icon-add" },
                              on: {
                                click: function($event) {
                                  return _vm.onAddGoods("onePriceGoods")
                                }
                              }
                            },
                            [_vm._v("添加商品")]
                          ),
                          _c("br"),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.activityGoodsList,
                                border: "",
                                stripe: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "商品名称", prop: "goodsName" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "商品数量",
                                  prop: "goodsNum",
                                  width: "150"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          staticClass: "bairun-input-fill",
                                          staticStyle: { height: "47px" },
                                          attrs: {
                                            min: 1,
                                            placeholder: "商品数量",
                                            "controls-position": "right"
                                          },
                                          on: { change: _vm.computeGoodsPrice },
                                          model: {
                                            value: scope.row.goodsNum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "goodsNum",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.goodsNum"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "规格",
                                  prop: "goodsSpecification"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "单位", prop: "goodsUnit" }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "销售价", prop: "goodsPrice" }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "最新成本价",
                                  prop: "goodsLatestCost"
                                }
                              }),
                              _c("el-table-column", {
                                attrs: { label: "操作", width: "60px" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-close",
                                            size: "mini",
                                            circle: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onDelActivityGoods(
                                                scope.row
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.goodsComponentFormData.dialogVisible
        ? _c("GoodsSelectComponent", {
            ref: "GoodsSelectComponent",
            attrs: { "goods-component-form-data": _vm.goodsComponentFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }